<template>
  <div class="detail-wrap">
    <el-dialog
      title="定向包详情"
      :visible.sync="showDialog"
      width="706px"
      :close-on-click-modal="false"
      top="8vh"
    >
      <div class="dialog-body">
        <ul class="detail-list">
          <li class="detail-item">
            <span class="item-label">名称：</span>
            <span class="item-value">男性拓展包</span>
          </li>
          <li class="detail-item">
            <span class="item-label">地域：</span>
            <span class="item-value"
              >北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，北京，</span
            >
          </li>
          <li class="detail-item">
            <span class="item-label">性别：</span>
            <span class="item-value">男</span>
          </li>
          <li class="detail-item">
            <span class="item-label">年龄：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">行为兴趣：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">抖音达人：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">媒体定向：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">平台：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">设备类型：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">网络：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">已安装用户：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">过滤已转化用户：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">Android版本：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">文章分类：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">运营商：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">新用户：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">手机品牌：</span>
            <span class="item-value">不限</span>
          </li>
          <li class="detail-item">
            <span class="item-label">手机价格：</span>
            <span class="item-value">不限</span>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    showModal() {
      this.showDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-body {
  .detail-list {
    padding: 0px;
    margin: 0px;
    list-style: none;
    .detail-item {
      display: flex;
      padding: 8px 0;
      font-size: 14px;
      .item-label {
        display: inline-block;
        width: 120px;
        color: rgba(0, 0, 0, 0.65);
        flex-shrink: 0;
      }
      .item-value {
        color: rgba(0, 0, 0, 0.82);
      }
    }
  }
}
</style>